import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.less';

const root = ReactDOM.createRoot(document.getElementById('simple-form'));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
